import React from 'react';
import { Section } from './Section';
import { Brain, Mic2, Key, RefreshCw, Link2, Lock } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  icon: Brain,
  title: 'Local AI Neural Network',
  desc: 'All processing happens on-device. No audio leaves your premises — except in the event of an alert.'
}, {
  icon: Mic2,
  title: 'Up to 4 Microphones Per Unit',
  desc: 'Wide acoustic coverage for large or complex spaces. Connect multiple rooms to a single Pod.'
}, {
  icon: Key,
  title: 'Custom Keyword Detection',
  desc: "Configure your own trigger words in addition to standard emergency terms like 'help,' 'fire,' or 'stop.'"
}, {
  icon: RefreshCw,
  title: 'Automatic Updates',
  desc: 'The system updates itself and is fully managed remotely. Recovery is handled without on-site intervention.'
}, {
  icon: Link2,
  title: 'Universal Compatibility',
  desc: 'Works with any alarm center via CloudSurgard. Zero integration needed on their end.'
}, {
  icon: Lock,
  title: 'Privacy by Design',
  desc: 'Audio is never stored. It is deleted within seconds. Only alert-triggering clips are transmitted.'
}];
export function Features() {
  return <Section id="features" className="bg-zinc-50 border-y border-zinc-200" data-id="element-46">
      <div className="mb-16" data-id="element-47">
        <span className="text-peoplecall tracking-wider text-sm font-semibold mb-4 block" data-id="element-48">
          Features
        </span>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold max-w-3xl leading-tight text-zinc-900" data-id="element-49">
          Built for real environments.
          <br data-id="element-50" />
          Engineered for reliability.
        </h2>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-51">
        {features.map((feature, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white border border-zinc-200 p-8 rounded-2xl hover:border-peoplecall/40 hover:shadow-lg transition-all duration-300 group" data-id="element-52">
            <div className="w-12 h-12 rounded-xl bg-peoplecall/10 flex items-center justify-center mb-6 group-hover:bg-peoplecall/15 transition-colors" data-id="element-53">
              <feature.icon className="w-6 h-6 text-peoplecall" data-id="element-54" />
            </div>
            <h3 className="text-xl font-bold text-zinc-900 mb-3" data-id="element-55">
              {feature.title}
            </h3>
            <p className="text-zinc-600 text-sm leading-relaxed" data-id="element-56">
              {feature.desc}
            </p>
          </motion.div>)}
      </div>
    </Section>;
}